import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCurrentChannel } from '../providers/BroadcastChannel.js';
import { Actions, type Message } from '../utils/index.js';

const useCrossTabCommunication = () => {
  const { currentChannel } = useCurrentChannel();
  const navigate = useNavigate();

  // Set up cross-tab communication
  useEffect(() => {
    const onMessage = (message: Message) => {
      const { action, data } = message;

      if (action === Actions.OPEN_PROFILE && data) {
        const { patientId } = data;

        navigate(`/patients/${patientId}`);
      }
    };

    if (currentChannel) {
      currentChannel.addEventListener('message', onMessage);
    }

    return function cleanup() {
      if (currentChannel) {
        currentChannel.removeEventListener('message', onMessage);
      }
    };
    // We're intentionally excluding props to run this effect only once
  }, [currentChannel]); // eslint-disable-line react-hooks/exhaustive-deps

  return;
};

export default useCrossTabCommunication;
